import { ElMessage, ElMessageBox } from "element-plus";
import { markRaw } from 'vue'
import { WarnTriangleFilled } from '@element-plus/icons-vue'

import { WebsiteUrl } from "../../utils";
import Loading from "../../utils/Loading"; //获取加载组件
import Auth from "@/utils/auth";
import $Public from "../../utils/Public";
import Bus from "../../utils/EventBus";
import Api_Platform from "../../api/FrontEnd/Platform";
import Api_Member from "../../api/FrontEnd/Member";

import ComponentsLogin from "./Login";
import ComponentsRegister from "./Register";
import ComponentsResetPassword from "./ResetPassword";
import ComponentsExchangePopover from "./ExchangePopover";

export default {
	name: 'ComponentsTop',
	components: {
		ComponentsLogin,
		ComponentsRegister,
		ComponentsResetPassword,
		ComponentsExchangePopover
	},
	props:{

	},
	data(){
		return{
			ValueData:'111',

			ImageLogoUrl:'',
			ImageLogoUrl:WebsiteUrl()+'/images/ModuleBoxTopBodyBodyLogo.png',
			ImageElement1Url:WebsiteUrl()+'/images/ModuleBoxTopBackgroundElement1.png',
			ImageMyIconUrl:WebsiteUrl()+'/images/MyIcon.png',
			ImageSearchIconUrl:WebsiteUrl()+'/images/SearchIcon.png',

			Info:Auth.getInfo()?JSON.parse(Auth.getInfo()):{},
			Token:Auth.getToken(),

			NavData:[],

			LoginVisible:false,
			RegisterVisible:false,
			ResetPasswordVisible:false,

			ExchangePopoverVisible:false,
		}
	},
	methods:{
		GetNavData(){
			//判断是否已赋值
			if($Public?.NavData.length <= 0){
				//获取接口返回值
				Loading.LoadingShow();
				let RequestData = {};
				let ReturnData = Api_Platform.GetNavData(RequestData);
				ReturnData.then(response => {
					// console.log(response);
					Loading.LoadingHide();
					let State = response['Data'][0].State;
					let Message = response['Data'][0].Message;
					if(State == 'Success'){
						let Data = JSON.parse(response['Data'][0].Data);
						this.NavData = Data?.NavData?.map(Item => {
							return {
								...Item,
								Path:Item.Value
							}
						});

						// console.log(this.NavigationData);
					}else{
						this.NavData = [];
					}
				})
			}else{
				//直接赋值
				this.NavData = $Public?.NavData;
			}
		},
		ToPath(Path){
			// console.log(Path);
			this.$router.push(Path);
		},

		onClickMy(){
			this.Token = Auth.getToken();
			if(this.Token){
				this.$router.push('/My');
			}else{;
				this.LoginShow();
			}
		},
		LoginShow(){
			this.LoginVisible = true;
		},
		LoginHide(Value){
			this.LoginVisible = Value;
			this.$emit("ExternalRegisterHide",null);
		},
		RefreshMemberInfo(){
			//登录成功
			this.Info = JSON.parse(Auth.getInfo());
			this.Token = Auth.getToken();
			// console.log(this.Info,this.Token);

			//判断是否为档案库-剧目详情
			if(this.$route.path.includes("/Archives/Repertoires/")){
				Bus.emit("onArchivesRepertoiresDetail",null);
			}
			//判断是否为档案库-成员详情
			if(this.$route.path.includes("/Archives/ActorLibrary/")){
				Bus.emit("onArchivesActorLibraryDetail",null);
			}
		},
		RegisterShow(){
			this.LoginHide();
			this.RegisterVisible = true;
		},
		RegisterHide(Value){
			this.RegisterVisible = Value;
			this.$emit("ExternalRegisterHide",null);
		},
		RegisterBack(Value){
			this.RegisterVisible = Value;
			this.LoginShow();
		},
		ResetPasswordShow(){
			this.LoginHide();
			this.ResetPasswordVisible = true;
		},
		ResetPasswordHide(Value){
			this.ResetPasswordVisible = Value;
		},
		ResetPasswordBack(Value){
			this.ResetPasswordVisible = Value;
			this.LoginShow();
		},
		ExchangePopoverShow(){
			this.ExchangePopoverVisible = true;
		},
		ExchangePopoverHide(Value){
			this.ExchangePopoverVisible = Value;
		},

		onOut(){
			ElMessageBox({
				title: '系统提示',
				message: "是否确认退出账号？",
				type: 'warning',
				icon: markRaw(WarnTriangleFilled),
				confirmButtonText: "确认退出",
				confirmButtonClass:"ModuleBoxBodyBodyBodyBoxBasicBodyLeftOutBtnElMessageBoxConfirmButton",
			}).then(async (response) => {
				try {
					Loading.LoadingShow();
				
					let RequestData = {};
					let ReturnData = Api_Member.MemberCheckOut(RequestData);
					ReturnData.then(response => {
						Loading.LoadingHide();
						//console.log(response);

						let State = response['Data'][0].State;
						let Message = response['Data'][0].Message;
						if(State == 'Success'){
							Auth.removeToken();
							Auth.removeInfo();

							if(this.$route.path == "/My"){
								this.$router.push('/');
							}

							this.RefreshMemberInfo();

							this.Token = Auth.getToken();
							this.Info = JSON.parse(Auth.getInfo());

							//判断是否为档案库-剧目详情
							if(this.$route.path.includes("/Archives/Repertoires/")){
								Bus.emit("onArchivesRepertoiresDetail",null);
							}
							//判断是否为档案库-成员详情
							if(this.$route.path.includes("/Archives/ActorLibrary/")){
								Bus.emit("onArchivesActorLibraryDetail",null);
							}
							
							console.log(this.$route.path);

							// ElMessage.success(Message);
						}else{
							ElMessage.error(Message);
						}
					})
				}catch(err){
					//console.log(err);
				}
			})
			.catch((response) => {
				//console.log(response);
			})
		},
	},
	mounted(){
		Bus.on("onRegisterMember",(Value)=>{
			this.RegisterShow();
		});
		Bus.on("onLoginMember",(Value)=>{
			this.LoginShow();
		});
		Bus.on("onExchangePopover",(Value)=>{
			this.ExchangePopoverShow();
		});


		this.GetNavData();
	},
	watch: {

		
	},
	emits:{
		"ExternalRegisterHide":null,
	}
}

